import { track } from '@/lib/amplitude';
import { ref } from 'vue';

/**
 * Track if the user keeps their mouse over an element for at least 5 seconds.
 *
 * @returns Props that should be added onto the element you want to track (e.g.,
 * Chart).
 */
export const useTrackChartInteractionEvent = (eventName: string) => {
	const chartHoverTimeout = ref<ReturnType<typeof setTimeout>>();

	const onChartMouseEnter = () => {
		clearTimeout(chartHoverTimeout.value);
		chartHoverTimeout.value = setTimeout(() => {
			track(eventName);
		}, 5000);
	};

	const onChartMouseLeave = () => {
		clearTimeout(chartHoverTimeout.value);
	};

	return {
		onMouseenter: onChartMouseEnter,
		onMouseleave: onChartMouseLeave,
	};
};
